import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HcpSwitchoverApi } from '../../../apis/HcpSwitchoverApi/HcpSwitchoverApi.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IHcpSwitchoverBatch, IHcpSwitchoverCandidate } from '../HcpSwitchover.ts';

export const useRunHcpSwitchoverBatch = () => {
    const queryClient = useQueryClient();

    return useMutation<IHcpSwitchoverCandidate[], AppMedError, IHcpSwitchoverBatch>({
        mutationFn: (batch) => HcpSwitchoverApi.runBatch(batch),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.hcpSwitchoverReadiness] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.hcpSwitchoverLegacyHcps] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareProfessionals] });
        },
    });
};
